import type { DaySummary } from '@calorie/shared';

export function WaterGlassIcon({ className }: { className?: string }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6.5 3.5h11l-1.2 16a1.7 1.7 0 0 1-1.7 1.5H9.4a1.7 1.7 0 0 1-1.7-1.5z" />
    <path d="M7.6 10.5c1.8-.8 3.1.8 4.9 0s3.1.8 4.3.2" />
  </svg>;
}

export function WaterProgress({ water }: { water: DaySummary['water'] | undefined }) {
  if (!water?.enabled) return null;
  const size = 46;
  const stroke = 4;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = water.goalMl > 0 ? water.consumedMl / water.goalMl : 0;
  const fmt = (value: number) => Math.round(value).toLocaleString('ru-RU');

  return <div className="glass water-progress" aria-label={`Вода: ${fmt(water.consumedMl)} из ${fmt(water.goalMl)} миллилитров`}>
    <div className="water-ring">
      <svg viewBox={`0 0 ${size} ${size}`} role="presentation">
        <circle className="water-ring-track" cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={stroke} />
        <circle className="water-ring-value" cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - Math.min(ratio, 1))}
          transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      </svg>
      <WaterGlassIcon className="water-ring-icon" />
    </div>
    <div className="water-progress-copy"><span>Вода</span><strong>{fmt(water.consumedMl)} / {fmt(water.goalMl)} мл</strong></div>
    <span className="water-percent">{Math.round(Math.min(ratio, 1) * 100)}%</span>
  </div>;
}
